import { useContext } from "react";
import { useLocation, Outlet } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";
import NotFound from "../modules/swiftboard/not-found/page";
import { canAccessPath } from "../utils/path-access";

export default function ModuleRouteGuard() {
    const { allowedPaths, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) return null; 

    if (canAccessPath(allowedPaths, location.pathname)) {
        return <Outlet />
    }

    return <NotFound />;
} 